<a class="navbar-brand text-uppercase" [routerLink]="prevItem?.routerLink" [fragment]="prevItem?.fragment" (click)="navigateBack()">
    <span *ngIf="prevItem"><i class="fas fa-arrow-left mr-3"></i>back to {{prevItem.label}}</span> 
    <span *ngIf="!prevItem">Submission platform</span>
</a>


 